import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/Button/Button';
import { useDismissCelebration } from '@/features/onboarding';
import { t } from '@/lib/i18n';
import type { Member } from '../schemas';
import styles from './HireCelebrationBanner.module.css';

interface Props {
  member: Member;
  onDismissed?: () => void;
}

export function AddedMemberBanner({ member, onDismissed }: Props) {
  const navigate = useNavigate();
  const dismiss = useDismissCelebration(member.id);
  const positionName = member.positions?.[0]?.name ?? '';

  return (
    <aside className={styles.banner} role="status">
      <div className={styles.text}>
        <strong>
          {t('Meet {name} — {position}.', { name: member.first_name, position: positionName })}
        </strong>{' '}
        {t("{name}'s on the team and ready for the first Job.", { name: member.first_name })}
      </div>
      <div className={styles.actions}>
        <Button
          variant="primary"
          size="sm"
          onClick={() => void navigate(`/team/m/${member.id}/chat`)}
        >
          {t('Chat with {name} →', { name: member.first_name })}
        </Button>
        <button
          type="button"
          className={styles.close}
          aria-label={t('Dismiss')}
          onClick={() => dismiss.mutate(undefined, { onSettled: () => onDismissed?.() })}
        >
          ×
        </button>
      </div>
    </aside>
  );
}
